const sectionCardMediaSlider03Css = `
[data-type='section-card-media-slider-03'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-card-media-slider-03'] .card-header:not(:empty) {
  margin-bottom: 24px !important;
}

[data-type='section-card-media-slider-03'] .card-header h1,
[data-type='section-card-media-slider-03'] .card-header h2,
[data-type='section-card-media-slider-03'] .card-header h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 12px 0 !important;
}

[data-type='section-card-media-slider-03'] .card-header h1:last-child,
[data-type='section-card-media-slider-03'] .card-header h2:last-child,
[data-type='section-card-media-slider-03'] .card-header h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-media-slider-03'] .card-header p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-card-media-slider-03'] .card-header p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-media-slider-03'] .swiper {
  position: relative;
}

[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item {
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,
    rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.1) 0px 1px 2px;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  margin: 2px;
}

[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-content {
  margin-top: 16px;
}

[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-content h1,
[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-content h2,
[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-content h3 {
  font-size: 18px;
  line-height: normal;
  margin: 0 0 8px 0 !important;
}

[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-content h1:last-child,
[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-content h2:last-child,
[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-content h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-content p {
  font-size: 14px;
  margin-bottom: 8px !important;
}

[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-content p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item img {
  flex: 1;
  width: 100%;
  height: 100%;
  display: block;
  cursor: pointer;
  aspect-ratio: 1 / 1;
  object-fit: cover;
}

[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-video {
  flex: 1;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-video video {
  width: 100%;
  height: 100%;
  display: block;
  cursor: pointer;
}

[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-video .volume {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000000a1;
  color: white;
  border-radius: 50%;
  cursor: pointer;
}

[data-type='section-card-media-slider-03'] .swiper .swiper-wrapper .wrap-item .wrap-item-video .volume svg {
  width: 20px;
  height: 20px;
}

[data-type='section-card-media-slider-03'] .swiper-pagination {
  position: relative;
  margin-top: 20px;
}

[data-type='section-card-media-slider-03'] .swiper-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: var(--pagination-inactive-color, #cccccc);
}

[data-type='section-card-media-slider-03'] .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--pagination-active-color, #000) !important;
}

@container (max-width: 768px) {
  [data-type='section-card-media-slider-03'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-card-media-slider-03'] .card-header {
    padding-inline: 16px;
  }

  [data-type='section-card-media-slider-03'] .card-header h1,
  [data-type='section-card-media-slider-03'] .card-header h2,
  [data-type='section-card-media-slider-03'] .card-header h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-card-media-slider-03'] .card-header p {
    font-size: 14px;
  }
}
`;
export default sectionCardMediaSlider03Css;
